import { usePollDocumentBatch } from './hooks'

interface DocumentBatchPollerProps {
  documentBatchId: string
}

export const DocumentBatchPoller: React.FC<DocumentBatchPollerProps> = ({ documentBatchId }) => {
  usePollDocumentBatch(documentBatchId)

  return null
}
